import React, { useEffect, useState } from 'react'
import styles from '../styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../../../../components/Table'
import Modal from 'react-responsive-modal'
import Button from '../../../../components/Button'
import { addPersonCourses, getPersonCourses } from '../../../../actions/personnel/personnel'


export default function ModalLesson({ openModalLessons, closeModalLesons, mid }) {

    const dispatch = useDispatch()
    const { personnelLessonsList } = useSelector(state => state.personnel)

    const [selectedCourses, setSelectedCourses] = useState([])

    useEffect(() => {
        dispatch(getPersonCourses(mid))
    }, [dispatch])

    const handleSelectCourse = (cid) => {
        setSelectedCourses(prev =>
            prev.includes(cid)
                ? prev.filter(id => id !== cid)
                : [...prev, cid]
        )
    }

    const handleSubmit = async () => {
        if (selectedCourses.length > 0 && mid) {
            const success = await dispatch(addPersonCourses(mid, selectedCourses, 'lesson'))
            if (success) {
                closeModalLesons()
            }
        }
    }

    const renderRow = (course) => {
        const { cid, id, name, title } = course
        const courseId = cid || id
        const courseName = name || title
        const isSelected = selectedCourses.includes(courseId)

        return (
            <tr
                key={courseId}
                onClick={() => handleSelectCourse(courseId)}
                className={isSelected ? styles.selectedRow : ''}
                style={{ cursor: 'pointer' }}
            >
                <td>
                    <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleSelectCourse(courseId)}
                    />
                </td>
                <td>{courseName}</td>
            </tr>
        )
    }

    return (
        <Modal
            open={openModalLessons}
            onClose={closeModalLesons}
            classNames={{ modal: styles.lessonModal }}
        >
            <div className={styles.wrapper}>
                <h3>Выберите предметы для назначения</h3>
                <div style={{ margin: '1rem 0', backgroundColor: 'white', overflow: 'auto' }}>
                    <Table>
                        <thead>
                            <tr>
                                <th style={{ width: '40px' }}></th>
                                <th>Название предмета</th>
                            </tr>
                        </thead>
                        <tbody>
                            {personnelLessonsList?.length > 0 ? (
                                personnelLessonsList.map(renderRow)
                            ) : (
                                <tr>
                                    <td colSpan="2" className={styles.emptyTable}>
                                        Нет доступных предметов
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                <div className={styles.modalButtons}>
                    <Button onClick={handleSubmit} disabled={selectedCourses.length === 0}>
                        Назначить выбранные ({selectedCourses.length})
                    </Button>
                    <Button mode="white" onClick={closeModalLesons}>
                        Отмена
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
